export default "__VITE_ASSET__BDKVT2hX__"